<template>
  <div>
    <v-card v-if="dataOnlyZeros === 0" class="mb-4">
      <v-card-title class="pt-4">
        <v-container class="pa-0" fluid fill-height>
          <span class="pa-1 title">Dia do mês</span>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-layout class="pb-4" justify-center>
          <span class="body-2">Não há dados</span>
        </v-layout>
      </v-card-text>
    </v-card>
    <chart-card v-else title="Dia do mês" :data="chartData" :loader="loader" is-integer />
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import ChartCard from '@/components/ChartCard.vue'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    data: Array,
    module: String,
  },
  computed: {
    loader() {
      if (this.module === 'clientes') return ['clientes-dias-maiores-compras']
      if (this.module === 'produtos') return ['produtos-dias-maiores-compras']
      return ''
    },
    diaMesData() {
      return orderBy(this.data, 'NUM_DIA', 'asc')
    },
    dataOnlyZeros() {
      return this.data.reduce((accum, object) => {
        return accum + object['NUM_TOTAL_CUPONS']
      }, 0)
    },
    chartData() {
      return {
        labels: [...this.diaMesData.map((object) => object['NUM_DIA'])],
        datasets: [
          {
            label: 'Cupons',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.diaMesData.map((object) => object['NUM_TOTAL_CUPONS'])],
            fill: false,
          },
        ],
      }
    },
  },
}
</script>
